import { render } from "./FutureIncome.vue?vue&type=template&id=935d7970"
import script from "./FutureIncome.vue?vue&type=script&lang=js"
export * from "./FutureIncome.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__